import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { StoreInviteView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateSellerInvites } from "@/lib/query/core/invalidation";

type CreateStoreInviteInput = {
  storeSlug: string;
  email: string;
  roleIds: string[];
};

export function useCreateStoreInviteMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ storeSlug: _storeSlug, ...body }: CreateStoreInviteInput) =>
      apiJsonClient<StoreInviteView>(endpoints.seller.invites, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      }),
    onSuccess: async (_data, variables) => {
      await invalidateSellerInvites(queryClient, variables.storeSlug);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
